const fromStoreByCodeQueryToStoreByCode = (storeQuery)=>{
    if (!storeQuery) {
        return null;
    }
    try {
        const { code , name , streetName , streetNumber , town  } = storeQuery;
        return {
            code,
            name,
            streetName,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            town
        };
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, storeQuery);
        return null;
    }
};

export { fromStoreByCodeQueryToStoreByCode as default };
//# sourceMappingURL=fromStoreByCodeQueryToStoreByCode.js.map
